import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DropdownOption } from '../../../models';

@Component({
    selector: 'app-field-select',
    templateUrl: './field-select.component.html',
    styleUrls: ['./field-select.component.scss'],
    standalone: false
})
export class FieldSelectComponent implements OnInit, OnChanges {
    @Input() label?: string;
    @Input() hideLabel?: boolean;
    @Input() error?: string;
    @Input() disabled?: boolean;
    @Input() optionalString?: string;
    @Input() placeholder?: string;
    @Input() maxWidth?: string;
    @Input() readOnly?: boolean;
    @Input() options: DropdownOption<any>[];
    @Input() groupedOptions: { title: string; options: DropdownOption<any>[] }[];
    @Input() localOptions: DropdownOption<any>[];
    @Input() localGroupedOptions: { title: string; options?: DropdownOption<any>[]; value?: undefined }[];
    @Input() optionsToExclude: any[] = [];
    @Input() model: any;
    @Input() withGroups: boolean = false;
    @Output() modelChange = new EventEmitter();

    constructor() {}

    ngOnInit(): void {
        if (this.placeholder) {
            if (this.withGroups) {
                this.localGroupedOptions = [{ title: this.placeholder, value: undefined }, ...this.groupedOptions];
            } else {
                this.localOptions = [{ title: this.placeholder, value: undefined }, ...this.options];
            }
        }
    }

    emit($event) {
        if (this.readOnly) {
            return;
        }
        this.modelChange.emit($event);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.options && changes.options.currentValue) {
            if (this.placeholder) {
                this.localOptions = [{ title: this.placeholder, value: undefined }, ...changes.options.currentValue];
            } else this.localOptions = changes.options.currentValue;
        }

        if (changes.groupedOptions && changes.groupedOptions.currentValue) {
            if (this.placeholder) {
                this.localGroupedOptions = [
                    { title: this.placeholder, value: undefined },
                    ...changes.groupedOptions.currentValue
                ];
            } else this.localGroupedOptions = changes.groupedOptions.currentValue;
        }

        if (changes.optionsToExclude && changes.optionsToExclude.currentValue) {
            if (changes.optionsToExclude.currentValue.indexOf(this.model) != -1) {
                setTimeout(() => {
                    this.modelChange.emit(undefined);
                }, 0);
            }
        }
    }

    getOptionsToExclude() {
        if (this.optionsToExclude == null || this.optionsToExclude == undefined) {
            return [];
        }
        return this.optionsToExclude;
    }
}
